import {useEffect} from 'react';
import useRedux from 'infrastructure/js/hooks/useRedux';
import useLabels from 'infrastructure/js/hooks/useLabels';
import Header, {headerItemsLabels} from '../../../Common/Header/header';
import {MatSettingsMenuItemsIds} from '../../../../enums/navigationMenuItemsIds';
import {gridsNames} from '../../../../enums/gridsNames.js';
import QplsPendingRequestsViewGrid from './QplsPendingRequestsViewGrid/qplsPendingRequestsViewGrid';
import {jsxActions as headerSettingsActions} from '../../../../actions/Header/headerSettingsActions';
import {jsxActions as qplsPendingRequestsViewActions } from '../../../../actions/Administration/MatSettingsPage/qplsPendingRequestsViewActions';
import {jsxActions as qplsPendingRequestsViewGridActions} from '../../../../actions/Administration/MatSettingsPage/qplsPendingRequestsViewGridActions';
import {jsxActions as qplAcceptanceDecisionDialogActions} from '../../../../actions/Administration/MatSettingsPage/qplAcceptanceDecisionDialogActions';
import {jsxActions as fetchEntitiesActions} from '../../../../actions/FetchEntities/fetchEntitiesActions';
import { jsxActions as matSettingsPageActions } from '../../../../actions/Administration/MatSettingsPage/matSettingsPageActions.js';
import CommonDialogWrapper from '../../../Dialogs/CommonDialogWrapper/commonDialogWrapper';
import QplAcceptanceDecisionDialog from '../QplAcceptanceDecisionDialog/qplAcceptanceDecisionDialog';
import {dialogsNames} from '../../../../enums/dialogsNames';



const getState = (state) => {
  let grid = state.grid?.get(gridsNames.ADMINISTRATION_MAT_SETTINGS_QPLS_PENDING_REQUESTS) || null;

  return {
    sHasRows: grid?.get('rows')?.size > 0 || false,
  };
};

const allActions = {
  headerSettingsActions,
  qplsPendingRequestsViewActions,
  qplsPendingRequestsViewGridActions,
  qplAcceptanceDecisionDialogActions,
  fetchEntitiesActions,
  matSettingsPageActions: matSettingsPageActions,
};

export default function QplsPendingRequestsView(props) {

  const labels = useLabels('mat.administration.matsettings.qplsPendingRequests.view.');
  const { state, actions } = useRedux(allActions, getState);


  useEffect(() => {
    actions.matSettingsPageActions.onSelectedMenuItemChanged(MatSettingsMenuItemsIds.NAV_ELEMENT_QPLS_PENDING_REQUESTS);
  }, []);


  const getHeaderItems = () => {

    return  {
      buttons: [
        //Note: Currently there is no filters for this grid
        // {
        //   id: 'clearFilters',
        //   label: '',
        //   icon: 'pl pl-filter-clear',
        //   action: actions.qplsPendingRequestsViewActions.clearFilters,
        //   tooltip: headerItemsLabels.CLEAR_FILTERS,
        // },
        {
          id: 'refresh',
          label: '',
          icon: 'pl pl-refresh',
          action: actions.qplsPendingRequestsViewActions.reload,
          tooltip: headerItemsLabels.REFRESH,
        },
        ],
      kebab: {}
    };
  }

  return (
    <div className="administration-view">
      <div className="title">{labels.get('title')}</div>

      <Header {...getHeaderItems()}/>

      <QplsPendingRequestsViewGrid actions={{...actions.qplsPendingRequestsViewGridActions}}
                                                exportCoCTestSetDetailsToPdf={actions.qplsPendingRequestsViewActions.exportCoCTestSetDetailsToPdf}
                                                showAcceptanceDecisionDialog={actions.qplsPendingRequestsViewActions.showAcceptanceDecisionDialog}
      />

      <CommonDialogWrapper dialogComponent={QplAcceptanceDecisionDialog}
                           dialogName={dialogsNames.QPL_ACCEPTANCE_DECISION_DIALOG}
                           actions={actions.qplAcceptanceDecisionDialogActions}
                           reloadParentComponent={actions.qplsPendingRequestsViewActions.reload}
      />

    </div>
  )
}
